import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 加载 element 组件库
import ElementUI from 'element-ui'
// 加载 element 组件库的样式
import 'element-ui/lib/theme-chalk/index.css'
// 全局注册 element 组件库
Vue.use(ElementUI)

// 引入高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '5b09385c25e22b58cafe9b290b0ffeb0',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
});

// wow.js动画
import wow from 'wowjs'
import 'wowjs/css/libs/animate.css';
Vue.prototype.$wow = wow

import Jsrsasign from 'jsrsasign'
Vue.prototype.$jsrsasign = Jsrsasign


//引入https.js
import api from './api/index.js'
// import token from './api/token.js'
Object.assign(Vue.prototype, {
  api, //接口地址全局封装
  // token
});
// import QRcode from './components/QRcode'
// Vue.use(QRcode);

// Export components
// export default QRcode
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
